import React, {useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import Loading from '../general/Loading';
import '../css/components/AddedCoupon.css';

const AddedCoupon = ({setResponse}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState('');
    const [showDelete, setShowDelete] = useState(false);
        const [searchQuery, setSearchQuery] = useState('');
    const [coupon, setCoupon] = useState([]);


        useEffect(() => {
            const fetchCoupon = async () => {
                setLoading(true);
                try {
                    const response = await fetch('https://api.hargharmart.com/get-coupon');
    
                    if (response.ok) {
                        const data = await response.json();
                        setCoupon(data);
                        setLoading(false);
                    } else {
                        setLoading(false);
                        console.error('Failed to fetch coupon');
                    }
                } catch (error) {
                    setLoading(false);
                    console.error('Error fetching data:', error);
                }
            };
    
            fetchCoupon();
        }, []);
        
            const filterCoupon = coupon.filter(myItem =>
            (myItem.name?.toLowerCase().includes(searchQuery.toLowerCase()) || '')
        );


            const handleShowDelete = (product) => {
      setSelectedProduct(product);
      setShowDelete(true);
    }


          const handleDelete = async (productId) => {
    try {
      const response = await fetch(`https://api.hargharmart.com/remove-coupon/${productId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setCoupon((prevProducts) => prevProducts.filter((product) => product.id !== productId));
        setShowDelete(false);
        setResponse({ message: 'Coupon deleted successfully!', status: 'success' });
        setTimeout(() => {
          setResponse('');
        }, 2000);
      } else {
                setResponse({ message: 'Unable to Delete Coupon.', status: 'error' });
        setTimeout(() => {
          setResponse('');
        }, 2000);  
      }
    } catch (error) {
      console.error('Error deleting product:', error);
    }
  };


  return (
    <>
    <section className='my-4'>
      <div className='px-4'>
        <div className='d-flex justify-content-between'>
          <p className='page-title'>Added Coupons</p>
          <button className='edit-btn' onClick={() => navigate('/add-coupon')}>Add Coupon</button>
        </div>

                    <div className='d-flex bg-white rounded-2 py-2 my-3'>
                        <i class="fa-solid fa-magnifying-glass text-darkblue px-2"></i>
                        <input
                            type="text"
                            className="profile-control rounded-2 border-0 bg-white w-100 py-0"
                            placeholder="Search Coupon"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>

<div className='row'>
              {filterCoupon.map(product => (
                <div className='col-xl-4 col-lg-6 col-md-6 mb-3'>
                  <div className='coupon-area'>

<div>
<p className='fw-semibold'>{product.code}</p>
<p className='para-text mb-0'>{product.name}<br />{product.discount_type == 'amount' && '₹'}{product.amount}{product.discount_type == 'percent' && '%'}</p>
<span className='para-text'>(Minimum Order Value of ₹{product.order_value})</span>

</div>

<div className='align-content-center text-center my-2'>
<span className='ms-2 close-btn bg-light text-dark' onClick={() => handleShowDelete(product)}>Remove <i class="fa-solid fa-xmark"></i></span>    
    </div>

</div>
</div>

              ))}
</div>
{/* row ends */}

        </div>
      </section>

{showDelete && (
  <>
                                  <section className="detail-dialog animate__animated animate__zoomIn px-2">
                                    <div className='detail-dialog-inner text-center col-lg-4 col-11 mx-auto px-lg-5 py-lg-5 px-3 py-3'>

<p className='page-title fs-6'>Want to Remove Coupon: '{selectedProduct.code}'?</p>

<button className='edit-btn' onClick={() => handleDelete(selectedProduct.id)}>Yes</button>&nbsp;&nbsp;
<button className='close-btn' onClick={() => setShowDelete(false)}>No</button>

</div>
</section>
  </>
)}

      {loading && <Loading setLoading={setLoading} />}
    </>
  )
}

export default AddedCoupon
